import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadDriverReservationActions from "../../store/actions/BulkUploadDriverReservation";
import BulkUploadFile from "../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <DriverReservationUpload>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="DriverReservationActionsUpload"
        uploadUrl="/reservation/bulk-update/ack"
        sampleURL="/sample/bulk-driver-reservation-sample.csv"
        id="DriverReservationTestId"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Driver Reservations Bulk Update"
        getUploadUrl={getUploadUrl}
      />
    </DriverReservationUpload>
  );
};

const DriverReservationUpload = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUploadDriverReservationActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
